export default "__VITE_ASSET__1QCq6HEm__"